// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__KEbJa","footer_container":"Footer_footer_container__p1W3G","p":"Footer_p__QGN13"};